import { AppRoleSummary } from '../administration/approle';
import { GridFieldDefinition } from './GridFieldText';

export class GridFieldAuthorizationListing{
  Id: number;
  canView?: boolean;
  canAdd?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  defaultCanView?: boolean;
  defaultCanAdd?: boolean;
  defaultCanEdit?: boolean;
  defaultCanDelete?: boolean
}

export class GridFieldAutorizationSummary extends GridFieldAuthorizationListing{
  gridFieldDefinition: GridFieldDefinition;
  appRole: AppRoleSummary;

  constructor(){
    super();
    this.Id = 0;
    this.canView = false;
    this.canAdd = false;
    this.canEdit = false;
    this.canDelete = false;
    this.appRole = new AppRoleSummary();
    this.gridFieldDefinition = new GridFieldDefinition();
    this.defaultCanView = false;
    this.defaultCanAdd = false;
    this.defaultCanEdit = false;
    this.defaultCanDelete = false;
  }
}
